import gql from "graphql-tag";

const RenewProps = gql`
    fragment RenewProps on SubscriptionRenewal {
        id
        amount
        days
        renewedBy {
            id
            surname
            first_name
            middle_name
            type {
                id
                name
            }
            designation {
                id
                name
            }
            email
            department {
                id
                name
            }
        }
        subDate
    }
`;
const Props = gql`
    fragment SubProps on SubscriptionModel {
        id
        nextSubDate
        amount
        currency
        amount
        site {
            id
            name
            email
            logo
        }
        remainingDays
        lastUpdate
        creator {
            id
            first_name
            surname
            middle_name
            email
            image
            designation {
                id
                name
            }
            department {
                id
                name
            }
            type {
                id
                name
            }
        }
        firstSubDate
    }
`;

const GET_SUBS = gql`
    query GetSubs($page: Int, $limit: Int, $site: ID, $author: ID, $dateRange: DateRangeInput) {
        GetServiceSubscribers(page: $page, limit: $limit, site: $site, author: $author, dateRange: $dateRange) {
            docs {
                ...SubProps
            }
            page
            limit
            totalDocs
            totalPages
            nextPage
            prevPage
        }
        GetManyParentSite(page: 1, limit: 1000) {
            docs {
                id
                email
                name
                sites {
                    id
                    name
                    email
                }
            }
        }
    }
    ${Props}
`;

const NEW_SUB = gql`
    mutation NewSub($model: SubscriptionInput!) {
        SubscribeToService(model: $model) {
            message
            doc {
                ...SubProps
            }
        }
    }
    ${Props}
`;

const GET_RENEWAL = gql`
    query GetServiceRenewal($id: ID!) {
        GetServiceRenewalList(id: $id) {
            page
            nextPage
            prevPage
            totalDocs
            totalPages
            limit
            docs {
                ...RenewProps
            }
        }
    }
    ${RenewProps}
`;
const RENEW_SERVICE = gql`
    mutation RenewService($id: ID!, $model: SubscriptionRenewalInput!) {
        RenewSubscription(id: $id, model: $model) {
            message
            doc {
                ...RenewProps
            }
        }
    }
    ${RenewProps}
`;
export { GET_SUBS, NEW_SUB, GET_RENEWAL, RENEW_SERVICE };
